// @flow
import React from "react"
import Link from "gatsby-link"
import injectSheet from "react-jss"
import classNames from 'classnames'

import { styles } from './Styles/Navbar.Style'

import logo from '../images/Partsee-logo.png'
import logoBlack from '../images/partsee-logo-310x310.png'

export type NavItem = {
  action: Function,
  content: any
}

type State = {
  visible: boolean
}

type Props = {
  pageTitle: string,
  pageDefinitions: string,
  sticky?: boolean,
  whitebackground?: boolean,
  rightItems: NavItem[],
  leftItems: NavItem[],
  classes: Object
}

class NavBar extends React.Component {
  props: Props

  constructor (props) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
    this.state = {
      visible: this.props.sticky ? false : true
    }
  }

  handleScroll(e) {
    const {sticky} = this.props
    if (sticky && window.pageYOffset > 150) {
      this.setState ({
        visible: true
      })
    } else if (sticky && window.pageYOffset < 150) {
      this.setState ({
        visible: false
      })
    }
  }

  componentDidMount() {
    if (this.props.sticky) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render () {

   const {
    classes,
    rightItems,
    leftItems,
    pageTitle,
    pageDefinitions,
    sticky,
    whitebackground
  } = this.props

   return (
     <div className={classNames(classes.navbarStaticTop, {
        [classes.sticky]: sticky,
        [classes.whitebackground]: whitebackground,
        [classes.visible]: this.state.visible
      })}>
        <div className={classes.navbarExpanded}>
          <div className={classes.leftItems}>
            <div className={classes.brand}>
              <img src={whitebackground ? logoBlack : logo} alt='Partsee logo' height='48' />
            </div>
          </div>
          <div className={classes.rightItems}>
            <a className={classNames(classes.login, {
              [classes.darkoutline]: whitebackground
            })}
              href="https://app.partsee.com">
              Login
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(NavBar)



// WEBPACK FOOTER //
// ./src/components/Navbar.jsx